import { render, staticRenderFns } from "./PolizaDataIndex.vue?vue&type=template&id=14e31475&scoped=true&"
import script from "./PolizaDataIndex.vue?vue&type=script&lang=js&"
export * from "./PolizaDataIndex.vue?vue&type=script&lang=js&"
import style0 from "./PolizaDataIndex.vue?vue&type=style&index=0&id=14e31475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e31475",
  null
  
)

export default component.exports